import AppConfig from "@/config/appConfig";
import {itExist} from "@/utils/general-utils";

/**
 * Redirect to localhost if the login request is coming from a dev server
 *
 * @param fullPath
 * @link https://jasmin.clasp-infra.com/jira/browse/IT01FSHDPP-334
 */
export function manageLocalhostRedirection(fullPath: string): void {
  const stateRegex = new RegExp(`(&state=)(.*?)$`);
  const state = fullPath.match(stateRegex)?.[2];

  if (AppConfig.DARE_ENV === 'int' && itExist(state) && state[state.length - 1] === '0') {
    window.location.replace(`https://dareqr:8081${fullPath}`);
  }
}
